(() => {
  const cfg = document.querySelector('[data-cda-fragrance-catalog]');
  if (!cfg) return;
  let catalog;
  try { catalog = JSON.parse(cfg.textContent); } catch { return; }
  const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const fragrances = [
    ['Pendant la Récréation', 'Tilleul et mimosa', '#B56D40'],
    ['Fraîcheur d’été', 'Menthe sauvage et citronnelle', '#62864A'],
    ['Mon Roudoudou', 'Citron sucré', '#B78B27'],
    ['Flânerie Gourmande', 'Fruits rouges', '#A43849'],
    ['Douceur d’Antan', 'Rose et lilas', '#9C607B'],
    ['Jean-Choux', 'Musc blanc et fleurs blanches', '#4B7199'],
    ['La P’tite Église', 'Ambre et encens', '#70517F'],
    ['Promenade à Oléron', 'Algues marines', '#315F8C'],
    ['Balade aux escargots', 'Bois d’iris et fleurs d’acacia', '#5D7D63'],
    ['À l’ombre du Noyer', 'Noix verte et feuille de figue', '#805C3E']
  ].map(([name, notes, color], i) => ({name, notes, color, i, key:norm(name)}));
  const findScent = value => {
    const key = norm(value);
    return fragrances.find(f => key === f.key || key.includes(f.key));
  };
  const products = [...new Map((catalog.products || []).map(p=>[String(p.id),p])).values()];
  const byId = new Map(products.map(p => [String(p.id), p]));
  const byHandle = new Map(products.map(p => [p.handle, p]));
  let stages = {};
  let copy = {};
  let queued = false;
  const loaded = new Set();
  const imageKey = url => String(url || '').split('?')[0].split('/').pop();
  const scentValues = (p, v) => {
    const axes = (p.options || []).map(o => typeof o === 'string' ? o : o.name);
    const values = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
    const result = [];
    values.forEach((value, i) => {
      if (/parfum|fragrance|senteur|combinaison/i.test(axes[i] || '')) {
        if (/combinaison/i.test(axes[i] || '')) {
          String(value).split(/\s+-\s+/).forEach(part => { const f = findScent(part); if (f) result.push(f); });
        } else { const f = findScent(value); if (f) result.push(f); }
      }
    });
    return result;
  };
  const matchVariant = (p, fragrance) => {
    const matches = (p.variants || []).filter(v => scentValues(p, v).some(f => f.i === fragrance.i));
    return matches.sort((a,b) => Number(b.available)-Number(a.available) || scentValues(p,b).filter(f=>f.i===fragrance.i).length-scentValues(p,a).filter(f=>f.i===fragrance.i).length)[0];
  };
  const variantFor = (p, scope, requested) => {
    const input = scope?.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    const id = requested || input?.value;
    return p.variants.find(v => String(v.id) === String(id)) || p.variants.find(v => v.available) || p.variants[0];
  };
  const el = (name, attrs = {}, text) => {
    const n = document.createElementNS('http://www.w3.org/2000/svg', name);
    Object.entries(attrs).forEach(([key,value]) => n.setAttribute(key, value));
    if (text != null) n.textContent = text;
    return n;
  };
  function splitText(text, max) {
    if (text.length <= max) return [text];
    const words = text.split(' '); let best = 1; let delta = Infinity;
    for (let i = 1; i < words.length; i++) {
      const diff = Math.abs(words.slice(0,i).join(' ').length - words.slice(i).join(' ').length);
      if (diff < delta) { best = i; delta = diff; }
    }
    return [words.slice(0,best).join(' '), words.slice(best).join(' ')];
  }
  function createPhoto(p, v, forced) {
    const stage = stages[p.handle];
    if (!stage) return null;
    const selected = scentValues(p,v);
    if (!selected.length && !forced) return null;
    const svg = el('svg', {viewBox:'0 0 1000 1000', preserveAspectRatio:'xMidYMid meet', role:'img', 'aria-label':p.title + ' — ' + selected.map(f=>f.name).join(' / '), class:'cda-fragrance-photo'});
    svg.append(el('image',{href:stage.url,x:0,y:0,width:1000,height:1000,preserveAspectRatio:'xMidYMid meet'}));
    stage.zones.forEach(zone => {
      const f = selected[zone.slot || 0] || selected[0] || forced;
      if (!f) return;
      const x = zone.x, y = zone.y, w = zone.w, h = zone.h;
      const group = el('g',{transform:`translate(${x} ${y}) rotate(${zone.rotate || 0} ${w/2} ${h/2})`, fill:f.color});
      const lines = splitText(f.name, zone.wrap || 25);
      const longest = Math.max(...lines.map(l=>l.length));
      const fs = Math.min(zone.size || 18, w / (longest * .51));
      const leading = fs * 1.13;
      const nameY = Math.max(fs, h*.40 - (lines.length-1)*leading/2);
      lines.forEach((line,i)=>group.append(el('text',{x:w/2,y:nameY+i*leading,'text-anchor':'middle','font-family':'Georgia, serif','font-size':fs,'font-weight':'400'},line)));
      if (zone.notes !== false && h > 24) {
        const noteLines = splitText(f.notes,zone.noteWrap || 36);
        const nfs = Math.min(fs*.62, w / (Math.max(...noteLines.map(l=>l.length)) * .51));
        const ny = Math.min(h - (noteLines.length-1)*nfs*1.15, nameY + lines.length*leading + nfs*.5);
        noteLines.forEach((line,i)=>group.append(el('text',{x:w/2,y:ny+i*nfs*1.15,'text-anchor':'middle','font-family':'Georgia, serif','font-size':nfs},line)));
      }
      if (zone.line !== false) group.append(el('path',{d:`M ${w*.16} ${h-1} H ${w*.84}`,stroke:f.color,'stroke-width':.6,opacity:.5,fill:'none'}));
      svg.append(group);
    });
    return svg;
  }
  function paint(img,p,v,forced) {
    const stage = stages[p.handle];
    if (!stage || !img.parentElement || !v) return;
    const signature = p.id + ':' + v.id;
    const host = img.parentElement;
    host.dataset.fragrancePending=signature;
    const prior = [...host.children].find(n=>n.classList?.contains('cda-fragrance-photo'));
    if (prior?.dataset.signature === signature) return;
    const photo = createPhoto(p,v,forced);
    if (!photo) return;
    photo.dataset.signature = signature;
    host.classList.add('cda-fragrance-host');
    img.classList.add('cda-fragrance-original');
    const fit = getComputedStyle(img).objectFit;
    photo.setAttribute('preserveAspectRatio',fit==='cover'?'xMidYMid slice':'xMidYMid meet');
    photo.querySelector('image').setAttribute('preserveAspectRatio','xMidYMid meet');
    const show = () => {
      if (!img.isConnected || host.dataset.fragrancePending!==signature) return;
      [...host.children].filter(n=>n.classList?.contains('cda-fragrance-photo')).forEach(n=>n.remove()); host.append(photo); host.classList.add('cda-fragrance-ready');
    };
    if (loaded.has(stage.url)) show();
    else {
      const preload = new Image();
      preload.onload=()=>{loaded.add(stage.url);show();};
      preload.src=stage.url;
    }
  }
  function storyProducts() {
    const match = location.pathname.match(/\/pages\/(\d{2})-/);
    if (!match) return;
    const f = fragrances[Number(match[1])-1];
    if (!f) return;
    let section = document.querySelector('[data-cda-fragrance-products]');
    if (section?.dataset.fragranceLive === f.key) return;
    if (!section) { section=document.createElement('section'); section.dataset.cdaFragranceProducts=f.key; document.querySelector('#MainContent')?.append(section); }
    section.replaceChildren(); section.dataset.fragranceLive=f.key; section.className='cda-scent-products';
    const intro=document.createElement('div'); intro.className='cda-scent-products__intro';
    const heading=document.createElement('h2'); heading.textContent='Retrouvez '+f.name;
    const lead=document.createElement('p');lead.textContent='Les créations de ce souvenir, avec la fragrance déjà sélectionnée.';
    intro.append(heading,lead);section.append(intro);
    const grid=document.createElement('div');grid.className='cda-scent-products__grid';
    products.forEach(p=>{
      if (!stages[p.handle] && !copy.profiles?.[p.handle]) return;
      const v=matchVariant(p,f);if(!v)return;
      const a=document.createElement('a');a.className='cda-scent-product';a.href='/products/'+p.handle+'?variant='+v.id;
      const media=document.createElement('div');media.className='cda-scent-product__media';
      const photo=createPhoto(p,v,f);
      if(photo)media.append(photo);
      else {const img=document.createElement('img');img.src=p.featured_image;img.alt=p.title+' — '+f.name;img.loading='lazy';img.width=1000;img.height=1000;media.append(img);}
      const cardCopy=document.createElement('div');cardCopy.className='cda-scent-product__copy';
      const name=document.createElement('h3');name.textContent=p.title;
      const selection=document.createElement('p');selection.textContent=v.title;
      const price=document.createElement('strong');price.textContent=new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(v.price/100);
      const action=document.createElement('span');action.textContent='Voir le produit →';
      cardCopy.append(name,selection,price,action);a.append(media,cardCopy);grid.append(a);
    });
    section.append(grid);
    section.dataset.cdaReady='true';
  }
  function renderFragranceDetails(p,v,scope) {
    const profile=copy.profiles?.[p.handle];
    const picker=scope?.matches('variant-picker')?scope:scope?.querySelector('variant-picker')||document.querySelector('variant-picker[data-product-id="'+p.id+'"]');
    if(!profile||!picker||!v)return;
    const selections=scentValues(p,v);
    if(!selections.length)return;
    const family=copy.families[profile.family];
    if(!family)return;
    const host=document.querySelector('.product-information__media')||picker.parentElement;
    let block=host.querySelector(':scope > .cda-fragrance-details');
    const signature=p.id+':'+v.id;
    if(block?.dataset.variantSignature===signature)return;
    const next=document.createElement('section');
    next.className='cda-fragrance-details';next.dataset.variantSignature=signature;
    next.setAttribute('aria-label',copy.labels.details);next.setAttribute('aria-live','polite');next.setAttribute('aria-atomic','true');
    const make=(tag,className,text)=>{const n=document.createElement(tag);if(className)n.className=className;if(text!=null)n.textContent=text;return n;};
    const slogan=make('p','cda-fragrance-details__slogan',family.slogan);
    const axes=(p.options||[]).map(o=>typeof o==='string'?o:o.name);
    const multiCar=axes.some(a=>/diffuseur voiture/i.test(a));
    const unique=new Map();
    selections.forEach((s,i)=>{
      const role=multiCar?(i===0?copy.labels.carDiffuser:copy.labels.carSpray):(selections.length>1?copy.labels.bottle.replace('{number}',String(i+1)):'');
      const entry=unique.get(s.i)||{scent:s,roles:[]};if(role)entry.roles.push(role);unique.set(s.i,entry);
    });
    unique.forEach(({scent,roles},index)=>{
      const info=copy.fragrances[scent.i];if(!info)return;
      const article=make('article','cda-fragrance-details__scent');article.style.setProperty('--cda-scent-color',scent.color);
      if(roles.length)article.append(make('p','cda-fragrance-details__role',roles.join(' · ')));
      article.append(make('h2','cda-fragrance-details__name',info.name));
      if(!next.children.length)article.append(slogan,make('p','cda-fragrance-details__intro',family.intro));
      article.append(make('p','cda-fragrance-details__hook',info.hook));
      article.append(make('p','cda-fragrance-details__story',info.story+' '+family.context));
      article.append(make('h3','cda-fragrance-details__subtitle',info.subtitle));
      const notes=make('dl','cda-fragrance-details__notes');
      info.notes.forEach(note=>{
        const row=make('div','cda-fragrance-details__note');
        row.append(make('dt','',note.kind));
        const dd=make('dd','');dd.append(make('strong','',note.label),make('p','',note.text));row.append(dd);notes.append(row);
      });
      article.append(notes);next.append(article);
    });
    if(block)block.replaceWith(next);else host.append(next);
  }

  function refresh() {
    queued=false;
    storyProducts();
    const handle=location.pathname.match(/\/products\/([^/?]+)/)?.[1];
    const main=byHandle.get(handle);
    const requested=new URL(location.href).searchParams.get('variant');
    if(main){
      const scope=document.querySelector('product-information')||document.querySelector('[data-product-id="'+main.id+'"]')||document.querySelector('#MainContent');
      const v=variantFor(main,scope,requested);
      renderFragranceDetails(main,v,scope);
      const primaryKey=imageKey(stages[main.handle]?.source_image||main.featured_image);
      document.querySelectorAll('#MainContent .product-media img, dialog .product-media img').forEach(img=>{
        if(img.closest('product-card'))return;
        if(imageKey(img.getAttribute('src'))===primaryKey||img.classList.contains('cda-fragrance-original'))paint(img,main,v);
      });
    }
    document.querySelectorAll('product-card[data-product-id]').forEach(card=>{
      const p=byId.get(card.dataset.productId);if(!p||!stages[p.handle])return;
      const href=card.querySelector('a[href*="/products/"]')?.href;
      const id=href?new URL(href,location.origin).searchParams.get('variant'):null;
      const v=variantFor(p,card,id);
      const img=card.querySelector('.product-media img');if(img&&(!stages[p.handle].source_image||imageKey(img.getAttribute('src'))===imageKey(stages[p.handle].source_image)))paint(img,p,v);
    });
  }
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(refresh);};
  async function start(){
    const assets=await Promise.allSettled([fetch(cfg.dataset.stagesUrl).then(r=>{if(!r.ok)throw Error();return r.json();}),fetch(cfg.dataset.copyUrl).then(r=>{if(!r.ok)throw Error();return r.json();})]);
    if(assets[0].status==='fulfilled')stages=assets[0].value;
    if(assets[1].status==='fulfilled')copy=assets[1].value;
    copy.labels=catalog.labels;
    refresh();
    document.addEventListener('change',e=>{if(e.target.closest('variant-picker, product-form, product-card')){schedule();setTimeout(schedule,300);setTimeout(schedule,900);}});
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('shopify:product:select',e=>{schedule();e.detail?.promise?.then?.(schedule).catch?.(()=>{});});
    document.addEventListener('variant:change',schedule);
    window.addEventListener('popstate',schedule);
    new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.classList?.contains('cda-fragrance-photo')&&!n.closest?.('.cda-fragrance-photo'))))schedule();}).observe(document.querySelector('#MainContent')||document.body,{childList:true,subtree:true});
  }
  window.CDAFragrances={norm,findScent,scentValues,matchVariant,createPhoto,refresh,fragrances,renderFragranceDetails,setCopy:value=>{copy=value;},setStages:value=>{stages=value;}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
